const OUT_RATE = 16000;

export function encodeWav(chunks, inRate) {
  const total = chunks.reduce((n, c) => n + c.length, 0);
  const ratio = inRate / OUT_RATE;
  const outLen = Math.floor(total / ratio);
  const samples = new Int16Array(outLen);
  let ci = 0, offset = 0, pos = 0;
  for (let i = 0; i < outLen; i++) {
    const end = Math.floor((i + 1) * ratio);
    let sum = 0, n = 0;
    while (pos < end && ci < chunks.length) {
      sum += chunks[ci][offset];
      n++; pos++; offset++;
      if (offset >= chunks[ci].length) { ci++; offset = 0; }
    }
    const v = Math.max(-1, Math.min(1, n ? sum / n : 0));
    samples[i] = v < 0 ? v * 0x8000 : v * 0x7fff;
  }
  const buf = new ArrayBuffer(44 + samples.length * 2);
  const dv = new DataView(buf);
  const str = (o, s) => [...s].forEach((ch, i) => dv.setUint8(o + i, ch.charCodeAt(0)));
  str(0, "RIFF"); dv.setUint32(4, 36 + samples.length * 2, true); str(8, "WAVE");
  str(12, "fmt "); dv.setUint32(16, 16, true); dv.setUint16(20, 1, true); dv.setUint16(22, 1, true);
  dv.setUint32(24, OUT_RATE, true); dv.setUint32(28, OUT_RATE * 2, true); dv.setUint16(32, 2, true); dv.setUint16(34, 16, true);
  str(36, "data"); dv.setUint32(40, samples.length * 2, true);
  new Int16Array(buf, 44).set(samples);
  return new Blob([buf], { type: "audio/wav" });
}
